import React, {
  createContext, useContext, useState, useLayoutEffect
} from 'react';
import { connect } from 'react-redux';
import runPreload from '../logic/preload';
import Forward from '../logic/forward';
import saveUserData from '../logic/save_user_data';
import PageLoader from '../../common/components/page_loader';
import Intro from '../../common/components/intro';
import Screening from '../../common/components/screening';
import Qualified from '../../common/components/qualified';
import CustomQualified from '../../common/components/custom_qualified';
import { fraudContext } from "../../common/contexts";
import { LastStepsComponents } from '../../common/logic/last_steps';
import { customMetricsByLocation } from "../../common/logic/eligible";
import WithOpenEnd from '../../common/components/metrics/customMetricsOpenEnd/withOpenEnd';
import Concept from './concept';

const resultContext = createContext(
  {
    answers: [],
    loops: [],
    preference_views: [],
    preference_selections: [],
    preference_answers: [],
    shelf_results: [],
    thought_bubbles: [],
    shelf_preference_selections: [],
    express_cart_exercise_results: []
  }
);

const Index = ({
  updateStep, updateConceptStep,
  updateConceptIndex, updateQuestionIndex, updateShelfStep,
  data, cIndex, qIndex, step, loading, conceptStep, shelfStep,
  changeLoadingState
}) => {
  const {
    qualified_custom_text, monadic, concepts,
    demographics, optional_demographics, screenings,
    translations
  } = data;

  const demographicsSorted = [
    demographics[0],
    demographics[2],
    demographics[1]
  ];

  useLayoutEffect(() => {
    runPreload(data, concepts, [ 'url', 'shelf_url' ], changeLoadingState);
  }, []);

  const result = useContext(resultContext);
  const { projectId, antiFraud, fraudProcessing, gaTrackingId } = useContext(fraudContext);

  const saveRequest = (status) => {
    saveUserData(data.save_url, status, result, data);
  };
  const currentConcept = () => (concepts[cIndex]);
  const currentQuestion = (questions) => (questions[qIndex]);

  const [ forwardEntity ] = useState(new Forward({
    updateStep,
    runSave: (status) => saveRequest(status),
    updateConceptStep,
    updateConceptIndex,
    updateQuestionIndex,
    updateShelfStep
  }));
  const goForward = () => {
    forwardEntity.forward(step, data, result, goNextConcept, projectId, antiFraud, gaTrackingId);
  };

  const goNextQuestion = (questions) => {
    forwardEntity.nextQuestion(
      qIndex, questions, result, goForward
    );
  };
  const goNextConcept = () => {
    forwardEntity.nextConceptStep(
      conceptStep, cIndex, currentConcept(), data, goForward
    );
  };

  const goNextShelfStep = () => {
    forwardEntity.nextShelfStep(shelfStep, currentConcept(), data, goNextConcept);
  };

  return (
    <>
      <PageLoader loading={ loading || fraudProcessing } />
      <section className="survey-layout">
        {
          !step &&
          <Intro
            task={ translations.base_intro }
            nextStep={ goForward }
          />
        }
        {
          step === 1 &&
          <Screening
            question={ currentQuestion(demographicsSorted) }
            nextStep={ () => { goNextQuestion(demographicsSorted); } }
            result={ result }
          />
        }
        {
          step === 2 &&
          <Screening
            question={ currentQuestion(optional_demographics) }
            nextStep={ () => { goNextQuestion(optional_demographics); } }
            result={ result }
          />
        }
        {
          step === 3 &&
          <Screening
            question={ currentQuestion(screenings) }
            nextStep={ () => { goNextQuestion(screenings); } }
            result={ result }
          />
        }
        {
          step === 4 && !qualified_custom_text &&
          <Qualified
            title={ translations.express_qualify_title }
            description={ translations.express_qualify_description }
            descriptionBottom={ translations.express_qualify_footer }
            nextStep={ goForward }
          />
        }
        {
          step === 4 && !!qualified_custom_text &&
          <CustomQualified
            content={ qualified_custom_text }
            nextStep={ goForward }
          />
        }
        {
          step === 5 &&
          <WithOpenEnd
            question={ currentQuestion(customMetricsByLocation(data.survey_metrics, "at_the_start")) }
            nextStep={ () => { goNextQuestion(customMetricsByLocation(data.survey_metrics, "at_the_start")); } }
            result={ result }
            mainResult={ result }
          />
        }
        {
          step === 6 &&
          <Concept
            concept={ currentConcept() }
            data={ data }
            nextStep={ goNextConcept }
            shelfStep={ shelfStep }
            nextShelfStep={ goNextShelfStep }
            monadic={ monadic }
            index={ conceptStep }
            conceptIndex={ cIndex }
            result={ result }
          />
        }
        {
          step === 7 &&
          <WithOpenEnd
            question={ currentQuestion(customMetricsByLocation(data.survey_metrics, "default")) }
            nextStep={ () => { goNextQuestion(customMetricsByLocation(data.survey_metrics, "default")); } }
            result={ result }
            mainResult={ result }
          />
        }
        {
          step === 8 &&
          <WithOpenEnd
            question={ currentQuestion(customMetricsByLocation(data.survey_metrics, "at_the_end")) }
            nextStep={ () => { goNextQuestion(customMetricsByLocation(data.survey_metrics, "at_the_end")); } }
            result={ result }
            mainResult={ result }
          />
        }
        <LastStepsComponents
          step={ step }
          lastStepsFrom={ 9 }
          translations={ translations }
          data={ data }
          nextStep={ goForward }
        />
      </section>
    </>
  );
};

const mapStateToProps = (state) => ({ ...state });

const mapDispatchToProps = (dispatch) => {
  return {
    updateStep: (step) => { return dispatch({ type: "UPDATE_STEP", value: step }); },
    changeLoadingState: (value) => { return dispatch({ type: "UPDATE_LOADING", value }); },
    updateConceptStep: (step) => { return dispatch({ type: "UPDATE_CONCEPT_STEP", value: step }); },
    updateConceptIndex: (cIndex) => { return dispatch({ type: "UPDATE_CONCEPT_INDEX", value: cIndex }); },
    updateShelfStep: (step) => { return dispatch({ type: "UPDATE_SHELF_STEP", value: step }); },
    updateQuestionIndex: (qIndex) => { return dispatch({ type: "UPDATE_QUESTION_INDEX", value: qIndex }); }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Index);
